export const APP_LOGO_STORAGE_KEY = "lipi_app_logo";
export const APP_LOGO_UPDATED_EVENT = "lipi-app-logo-updated";

export const getStoredAppLogo = () => {
  if (typeof window === "undefined") {
    return null;
  }

  return localStorage.getItem(APP_LOGO_STORAGE_KEY);
};

export const setStoredAppLogo = (value: string) => {
  localStorage.setItem(APP_LOGO_STORAGE_KEY, value);
  window.dispatchEvent(new CustomEvent(APP_LOGO_UPDATED_EVENT, { detail: value }));
};

export const clearStoredAppLogo = () => {
  localStorage.removeItem(APP_LOGO_STORAGE_KEY);
  window.dispatchEvent(new CustomEvent(APP_LOGO_UPDATED_EVENT, { detail: null }));
};
